import React from 'react';
import ReactDOM from 'react-dom';
import './pages/css/index.less';
import App from './App';
import reportWebVitals from './reportWebVitals';
import zhCN from "antd/es/locale-provider/zh_CN";
import {ConfigProvider} from "antd";

ReactDOM.render(
    <ConfigProvider locale={zhCN}>
    <App />
    </ConfigProvider>
    ,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
